import { FC, ReactNode } from 'react'
import cn from 'classnames'
import { useSwipeable } from 'react-swipeable'

interface DrawerProps {
  body: ReactNode
  isOpen: boolean
  semiOpened: boolean
  setSemiOpened: (isOpen: boolean) => void
}

export const Drawer: FC<DrawerProps> = ({ body, isOpen, semiOpened, setSemiOpened }) => {
  const handlers = useSwipeable({
    onSwipedUp: () => {
      setSemiOpened(false)
    },
  })
  return (
    <div
      {...handlers}
      className={cn(
        'bg-opacity-25 fixed inset-0 z-20 transform overflow-scroll bg-gray-900 shadow-sm ease-in-out',
        { 'translate-y-1/2 opacity-100 transition-opacity duration-500': semiOpened && isOpen },
        { 'translate-y-0 opacity-100 transition-opacity duration-500': !semiOpened && isOpen },
        { 'translate-y-full opacity-0 transition-all delay-500': !isOpen }
      )}
    >
      {body}
    </div>
  )
}
